import { TextField } from "@mui/material";
import styles from "./DrawingLabelModal.module.css";

const _2d_types = ['circle', 'rectangle', 'polygon']
const DrawingLabelModal = ({
    label,
    setLabel,
    color,
    setColor,
    fillColor,
    setFillColor,
    properties,
    handleCancel,
    handleSave,
    handlePropertyChange,
    removeProperty,
    addProperty,
    strokeWeight,
    setStrokeWeight,
    strokeOpacity,
    setStrokeOpacity,
    fillOpacity,
    setFillOpacity,
    type
}) => {
    //? TODO: use currentShape variable to identify the shape and hide fill color input accordingly
    // console.log(currentShape.getDrawingMode())
    const handleNumRangeCounter = (step, min, max, sign, fn) => {
        if (sign === "i") {
            fn((prev) => {
                return Math.min(parseFloat(prev + step), max);
            });
        } else if (sign === "d") {
            fn((prev) => {
                return Math.max(parseFloat(prev - step), min);
            });
        }
    };
    return (
        <div className={`${styles.drawinglabelContainer}`}>
            {/* <div className="draggable-container">drag</div> */}
            <div>
                <TextField variant="outlined" onChange={(e) => setLabel(e.target.value)} fullWidth size="small" label="Label (Required)" />
            </div>

            <div>
                <strong>Properties:</strong>
                <div
                    style={{ maxHeight: "300px", overflowY: "auto" }}
                    className="hideScrollbar"
                >
                    <div
                        style={{
                            display: "flex",
                            gap: 5,
                            marginTop: 4,
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div><label htmlFor="stroke-color">Stroke Color</label></div>
                        <div>
                            <input
                                type="color"
                                id="stroke-color"
                                className="form-control-color"
                                style={{
                                    width: 98,
                                    height: 25,
                                    border: "none",
                                    background: "none",
                                }}
                                value={color}
                                title={color}
                                onChange={(e) => setColor(e.target.value)}
                            />
                        </div>
                    </div>
                    {_2d_types.includes(type) && <div
                        style={{
                            display: "flex",
                            gap: 5,
                            marginTop: 4,
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div><label htmlFor="fill-color">Fill Color</label></div>
                        <div>
                            <input
                                type="color"
                                id="fill-color"
                                className="form-control-color"
                                style={{
                                    width: 98,
                                    height: 25,
                                    border: "none",
                                    background: "none",
                                }}
                                title={fillColor}
                                value={fillColor}
                                onChange={(e) => setFillColor(e.target.value)}
                            />
                        </div>
                    </div>}
                    {_2d_types.includes(type) && <div
                        style={{
                            display: "flex",
                            gap: 5,
                            marginTop: 4,
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>Fill Opacity</div>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        0.1,
                                        0.1,
                                        1,
                                        "d",
                                        setFillOpacity
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {"<"}
                            </button>
                            <div>{fillOpacity.toFixed(1)}</div>
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        0.1,
                                        0.1,
                                        1,
                                        "i",
                                        setFillOpacity
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {">"}
                            </button>
                        </div>
                    </div>}
                    <div
                        style={{
                            display: "flex",
                            gap: 5,
                            marginTop: 4,
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>Stroke Opacity</div>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        0.1,
                                        0.1,
                                        1,
                                        "d",
                                        setStrokeOpacity
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {"<"}
                            </button>
                            <div>{strokeOpacity.toFixed(1)}</div>
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        0.1,
                                        0.1,
                                        1,
                                        "i",
                                        setStrokeOpacity
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {">"}
                            </button>
                        </div>
                    </div>
                    <div
                        style={{
                            display: "flex",
                            gap: 5,
                            marginTop: 4,
                            justifyContent: "space-between",
                            alignItems: "center",
                        }}
                    >
                        <div>Stroke Weight</div>
                        <div className="d-flex justify-content-center align-items-center gap-2">
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        1,
                                        1,
                                        4,
                                        "d",
                                        setStrokeWeight
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {"<"}
                            </button>
                            <div>{strokeWeight.toFixed(1)}</div>
                            <button
                                onClick={() =>
                                    handleNumRangeCounter(
                                        1,
                                        1,
                                        4,
                                        "i",
                                        setStrokeWeight
                                    )
                                }
                                className="btn btn-dark hover-btn"
                            >
                                {">"}
                            </button>
                        </div>
                    </div>
                    <hr />
                    {properties.map((prop, idx) => (
                        <div
                            key={idx}
                            style={{
                                display: "flex",
                                gap: 2,
                                marginTop: 2,
                                justifyContent: "space-between",
                            }}
                        >
                            <TextField variant="outlined" size="small" label="Property" value={prop.key}
                                onChange={(e) =>
                                    handlePropertyChange(
                                        idx,
                                        "key",
                                        e.target.value
                                    )
                                } />
                                &nbsp;{":"}&nbsp;
                            <TextField variant="outlined" size="small" label="Value" value={prop.value}
                                onChange={(e) =>
                                    handlePropertyChange(
                                        idx,
                                        "value",
                                        e.target.value
                                    )
                                } />
                            
                            <button
                                className="btn btn-dark"
                                style={{fontSize:"12px", margin:"0 0 0 4px"}}
                                onClick={() => removeProperty(idx)}
                            >
                                ❌
                            </button>
                        </div>
                    ))}
                    <button
                        className="btn btn-dark btn-sm"
                        onClick={addProperty}
                        style={{ marginTop: 5 }}
                    >
                        + Add Property
                    </button>
                </div>
            </div>
            <hr />
            <button
                className="btn btn-dark btn-sm"
                disabled={label.trim().length === 0}
                onClick={handleSave}
            >
                Save
            </button>
            <button
                className="btn btn-dark btn-sm"
                onClick={handleCancel}
                style={{ marginTop: 2 }}
            >
                Cancel
            </button>
        </div>
    );
};

export default DrawingLabelModal;
